import type { BarsProps } from './types'
import type { ScheduleStats } from '../types'

import { useMemo } from 'react'

import { EMPTY, EXPIRED, ON_HOLD, weekDayNames } from '../constants'
import { generateWeek, getCurrentWeekDateFromDay } from '../functions'

import { Bar } from './bar'

export function Bars({ data, active, onClick }: BarsProps): JSX.Element {
  const days = useMemo(() => generateWeek(), [])

  const max = useMemo(
    () =>
      Object.keys(data ?? {}).reduce(
        (result, key) => Math.max(result, Number(data?.[key as keyof typeof data] ?? 0)),
        Number.NEGATIVE_INFINITY
      ),
    [data]
  )

  return (
    <div className='grid grid-flow-col grid-cols-[repeat(5,_1fr)_1rem_repeat(3,_1fr)] gap-2'>
      {days.map(
        (day, _i) =>
          day && (
            <Bar
              key={day}
              count={Number(data?.[day.toLowerCase() as keyof ScheduleStats] ?? 0)}
              height={max === 0 ? 0 : (data?.[day.toLowerCase() as keyof ScheduleStats] ?? 0) / max}
              title={day}
              subtitle={getCurrentWeekDateFromDay(day)}
              isActive={active === weekDayNames.indexOf(day)}
              onClick={() => {
                onClick(weekDayNames.indexOf(day))
              }}
            />
          )
      )}

      <div />

      <Bar
        count={data?.unscheduled}
        height={max === 0 ? 0 : (data?.unscheduled ?? 0) / max}
        title='Unscheduled'
        isActive={active === EMPTY}
        onClick={() => {
          onClick(EMPTY)
        }}
      />

      <Bar
        count={data?.on_hold}
        height={max === 0 ? 0 : (data?.on_hold ?? 0) / max}
        title='On Hold'
        isActive={active === ON_HOLD}
        onClick={() => {
          onClick(ON_HOLD)
        }}
      />

      <Bar
        count={data?.expired}
        height={max === 0 ? 0 : (data?.expired ?? 0) / max}
        title='Expired'
        isActive={active === EXPIRED}
        onClick={() => {
          onClick(EXPIRED)
        }}
      />
    </div>
  )
}
